import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
    name: 'exportHeaderDialog'
})
export default class ExportHeaderDialog extends Vue {
    // 弹框显示状态
    @Prop({ default: false }) visible!: boolean
    // 表头列表，结构 { id, filds, cnFilds, isShow }
    @Prop({ default: () => [] }) tableHeader!: any[]
    // 弹框标题
    @Prop({ default: '选择导出表头' }) title!: string

    // 选中的 filds 字段 key
    checkedHeaders: string[] = []
    // 全选状态
    checkAll = true
    // 半选状态
    isIndeterminate = false

    // 所有 filds
    get allFilds(): string[] {
        return this.tableHeader.map(h => h.filds)
    }

    // 全选/取消全选
    handleCheckAll(val: boolean) {
        this.checkedHeaders = val ? [...this.allFilds] : []
        this.isIndeterminate = false
    }

    // 勾选项变化
    handleCheckedChange(value: string[]) {
        this.checkAll = value.length === this.allFilds.length
        this.isIndeterminate = value.length > 0 && value.length < this.allFilds.length
    }

    // 确认导出
    handleConfirm() {
        if (this.checkedHeaders.length === 0) {
            this.$message.error('请至少选择一个表头')
            return
        }
        this.$emit('confirm', this.checkedHeaders.join(','))
        this.$emit('update:visible', false)
    }

    // 取消
    handleCancel() {
        this.$emit('update:visible', false)
    }

    @Watch('visible')
    onVisibleChange(val: boolean) {
        if (val) {
            // 打开时默认全选
            this.checkedHeaders = [...this.allFilds]
            this.checkAll = true
            this.isIndeterminate = false
        }
    }
}
